import React, { ReactElement } from "react";

import { useAppSelector } from "../../slices/hook";
import { getLayoutState } from "../../slices/layouts/reducer";

import { LAYOUT_NON_AUTH_THEME_TYPES } from "../../common/constants/layout";
import BasicLayout from "../../layout/none-auth-layout/basic";
import BoxedLayout from "../../layout/none-auth-layout/boxed";
import CoverLayout from "../../layout/none-auth-layout/cover";
import ModernLayout from "../../layout/none-auth-layout/modern";

import Tab from "common/components/tab/tab";

interface Props {
  children: ReactElement;
}

const NoneAuthLayoutSwitch = (props: Props) => {
  const { layoutNoneAuthTheme } = useAppSelector(getLayoutState);

  const renderComponent = () => {
    switch (layoutNoneAuthTheme) {
      case LAYOUT_NON_AUTH_THEME_TYPES.MODERN:
        return (
          <ModernLayout>
            <>
              <Tab.Container defaultActiveKey="emailLogin">
                <div className="lg:w-[20rem] mx-auto mt-10"></div>
                <div className="lg:w-[25rem] mx-auto">
                  <Tab.Content className="mt-5 tab-content">
                    <Tab.Pane eventKey="emailLogin" className="tab-pane" id="emailLogin">
                      {props.children}
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </>
          </ModernLayout>
        );
        break;
      case LAYOUT_NON_AUTH_THEME_TYPES.COVER:
        return <CoverLayout>{props.children}</CoverLayout>;
        break;
      case LAYOUT_NON_AUTH_THEME_TYPES.BOXED:
        return <BoxedLayout>{props.children}</BoxedLayout>;
        break;
      case LAYOUT_NON_AUTH_THEME_TYPES.BASIC:
      default:
        return <BasicLayout>{props.children}</BasicLayout>;
    }
  };

  return <React.Fragment>{renderComponent()} </React.Fragment>;
};

export default NoneAuthLayoutSwitch;
